import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useClientBranding } from '../contexts/ClientBrandingContext';
import {
  applyBrandCssVars,
  cssVarsFromClientBranding,
} from '../utils/partnerWorkspaceBrand';

/**
 * Traveller pages inherit Bespoke session tokens. Partner routes (login,
 * signup, and the workspace) stay on house or their own workspace theme.
 */
const BrandThemeSync = () => {
  const { pathname } = useLocation();
  const { branding } = useClientBranding();
  const skipClientTheme = pathname.startsWith('/partner') || pathname.startsWith('/admin');

  useEffect(() => {
    if (skipClientTheme) return undefined;
    applyBrandCssVars(cssVarsFromClientBranding(branding));
    return () => applyBrandCssVars(null);
  }, [skipClientTheme, branding]);

  return null;
};

export default BrandThemeSync;
